/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2022, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *                _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 */

import { Component, Input } from '@angular/core';
import { ClipboardService } from 'ngx-clipboard';
import { SvgIconRegistry } from '@ngneat/svg-icon';

import { faClipboardIcon } from 'IconLibrary/fontawesome/regular/clipboard';
import { faUnlinkIcon } from 'IconLibrary/fontawesome/regular/unlink';
import { AeroDialogService } from 'src/aero/aero-dialog/aero-dialog.service';

const ShareLinkIcons = {
  COPY: faClipboardIcon.name,
  UNLINK: faUnlinkIcon.name,
};

@Component({
  selector: 'bulb-private-share-link',
  templateUrl: './private-share-link.component.html',
  styleUrls: [
    './partials/share-link-copied-text.scss',
    './partials/private-share-link.scss',
    './partials/share-link-buttons.scss',
  ],
  standalone: false,
})
export class PrivateShareLinkComponent {
  @Input() public shareUrl: string;

  @Input() private unitId: string;

  public addShowCopyClass: boolean = false;

  public buttonIcons = {
    copyIcon: ShareLinkIcons.COPY,
    unlinkIcon: ShareLinkIcons.UNLINK,
  };

  constructor(
    private aeroDialogService: AeroDialogService,
    private clipboardService: ClipboardService,
    private svgIconRegistry: SvgIconRegistry,
  ) {
    this.svgIconRegistry.register([
      faClipboardIcon,
      faUnlinkIcon,
    ]);
  }

  public copyShareableLink() {
    this.clipboardService.copy(this.shareUrl);
    this.addShowCopyClass = true;
    setTimeout(() => {
      this.addShowCopyClass = false;
    }, 5000);
  }

  public createNewLinkModal() {
    const dialog = this.aeroDialogService.showCreateNewLinkDialog(this.unitId);

    dialog.onClose.subscribe((refreshResponse: any) => {
      if (refreshResponse) {
        this.shareUrl = refreshResponse.sharableLink;
      }
    });
  }
}
